import Gardener from '../gardener'
import _ from 'lodash'
import { Transform } from 'stream'
import Stream from 'stream'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATASET_LINK } = DataType
const SimpleDatasetGardener = Gardener.extend({
	initialize: function(opts = {}) {
		Gardener.prototype.initialize.apply(this, arguments)
		this.datasets = opts.datasets
		this.initialDatasetId = opts.initialDatasetId
	},

	_treeOptions: function () {
		let treeOpt = Gardener.prototype._treeOptions.apply(this, arguments)
		// so the -1 TOTAL option isn't treated as transient. But don't use
		// a value below -99 since visible linked field IDs start at -100
		treeOpt.transientId = -99

		treeOpt.label = selection => {
			if (selection.select('span').size()) {
				// See if we already drew the span. If so we don't need to reset the html.
				// It seems like resetting the html is fine, but for some reason it breaks the
				// tree actions event handling
				return
			}
			selection.html(d => {
				const dataset = this.tree.nodes[d.id]
				return `<span>${_.escape(dataset.get('label'))}</span>`
			})
		}

		treeOpt.accessors = { icon: 'icon' }
		var map = new Transform({ objectMode: true })

		map._transform = (node, enc, next) => {
			node.icon = !this.initialDatasetId || node.id == this.initialDatasetId
				? 'dataset' : DATASET_LINK
			map.push(node)
			next()
		}
		treeOpt.stream = treeOpt.stream.pipe(map)

		return treeOpt
	},

	_stream: function() {
		this._fakeStream = new Stream()
		this._fakeStream.pause = this._fakeStream.resume = _.identity
		return this._fakeStream
	},

	startStream: function() {
		_.forEach(this.datasets, d => this._fakeStream.emit('data', d))

		this._fakeStream.finished = true
		this._fakeStream.emit('end')

	}
})

export default SimpleDatasetGardener
SimpleDatasetGardener.__filename__ = 'components/bootslide/simple-dataset-gardener.js'
